<template>
  <v-app-bar
    app
    dark
    elevate-on-scroll
    height="64"
    :color="`rgb(137,18,51,${appBarOpacity})`"
  >
    <v-spacer />

    <!-- normal menu -->
    <v-toolbar-items
      v-show="$vuetify.breakpoint.mdAndUp"
      v-for="item in menuItems"
      :key="item.route"
    >
      <v-btn
        class="menu-button"
        :ripple="{ class: 'accent--text' }"
        text
        @click="scrollTo(item.route)"
      >
        {{ item.display }}
      </v-btn>
    </v-toolbar-items>

    <!-- Social media -->

    <v-toolbar-items>
      <v-btn
        href="https://www.facebook.com/damian.michalak.98229"
        target="_blank"
        text
      >
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn
        href="https://www.linkedin.com/in/rprdamianmichalak/"
        target="_blank"
        text
      >
        <v-icon>mdi-linkedin</v-icon>
      </v-btn>
    </v-toolbar-items>

    <!-- mobile menu -->
    <v-menu v-if="$vuetify.breakpoint.smAndDown" bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text>
          {{ $route.name }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="item in menuItems" :key="item.route">
          <v-btn class="menu-button" text @click="scrollTo(item.route)">
            <v-list-item-title>{{ item.display }}</v-list-item-title>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',
  data() {
    return {
      menuItems: [
        {
          route: 'home',
          display: 'Strona główna',
        },
        {
          route: 'o-kancelarii',
          display: 'Kim jesteśmy',
        },
        {
          route: 'doswiadczenie',
          display: 'Co robimy',
        },
        {
          route: 'blogi',
          display: 'Blogi',
        },
        {
          route: 'kontakt',
          display: 'Kontakt',
        },
      ],
      appBarOpacity: 0.4,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.updateAppBarOpacity);
  },
  destroyed() {
    window.removeEventListener('scroll', this.updateAppBarOpacity);
  },
  methods: {
    updateAppBarOpacity() {
      let newOpacity = window.scrollY / 200;
      if (newOpacity < 0.4) {
        this.appBarOpacity = 0.4;
      } else {
        this.appBarOpacity = newOpacity;
      }
    },
    scrollTo(elementId) {
      this.$router.push({ name: 'home' });
      this.$vuetify.goTo('#' + elementId);
    },
  },
};
</script>

<style scoped>
.menu-button:before {
  background-color: #671821;
}
.logo-link {
  text-decoration: none;
}
</style>
